export default "__VITE_ASSET__2f41b596__"